import { FormGroup, FormControl, Validators } from '@angular/forms'

export const dataPageOfAllergyForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const allergyForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  allergyId: new FormControl(null, []),
  allergyName: new FormControl(null, []),
  allergyType: new FormControl(null, []),
  allergyDescription: new FormControl(null, []),
  allergyReaction: new FormControl(null, []),
  comment: new FormControl(null, []),
  onSetDate: new FormControl(null, []),
  encID: new FormControl(null, []),
  personID: new FormControl(null, []),
  isResolved: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  resolvedDate: new FormControl(null, []),
  providerName: new FormControl(null, []),
  locationName: new FormControl(null, []),
  enteredBy: new FormControl(null, []),
  patientId: new FormControl(null, []),
  shortVisitDate: new FormControl(null, []),
  shortOnSetDate: new FormControl(null, []),
  savedValues: new FormControl(null, []),
  allergies: new FormControl(null, []),
})

export const baseForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
})

export const appontmentDtoForm = new FormGroup({
  providerId: new FormControl(null, []),
  providerName: new FormControl(null, []),
  apptDate: new FormControl(null, []),
  isResource: new FormControl(null, []),
  resourceId: new FormControl(null, []),
  resourceName: new FormControl(null, []),
  resourceList: new FormControl(null, []),
  providerList: new FormControl(null, []),
})

export const resourceForm = new FormGroup({
  providerId: new FormControl(null, []),
  providerName: new FormControl(null, []),
  resourceId: new FormControl(null, []),
  resourceName: new FormControl(null, []),
})

export const providerForm = new FormGroup({
  providerId: new FormControl(null, []),
  providerName: new FormControl(null, []),
})

export const dataPageOfAppointmentForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const appointmentForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  appointmentId: new FormControl(null, []),
  appointmentSubject: new FormControl(null, []),
  appointmentRoom: new FormControl(null, []),
  appointmentStatus: new FormControl(null, []),
  appointmentDate: new FormControl(null, []),
  patientName: new FormControl(null, []),
  appointmentCancelDate: new FormControl(null, []),
  appointmentReason: new FormControl(null, []),
  patientId: new FormControl(null, []),
  patientPersonID: new FormControl(null, []),
  appointmentNum: new FormControl(null, []),
  appointmentType: new FormControl(null, []),
  renderingProvider: new FormControl(null, []),
  isKept: new FormControl(null, []),
  isCanacelled: new FormControl(null, []),
  customName: new FormControl(null, []),
  appointmentTime: new FormControl(null, []),
})

export const appSettingsForm = new FormGroup({
  isTwoFactorOn: new FormControl(null, []),
  isArchiveInstance: new FormControl(null, []),
  carefinitySettings: new FormControl(null, []),
  isEmergencyTokenOn: new FormControl(null, []),
})

export const carefinitySettingsForm = new FormGroup({
  tasks: new FormControl(null, []),
  signOffQueue: new FormControl(null, []),
  labs: new FormControl(null, []),
  logoFile: new FormControl(null, []),
  logoFileDescription: new FormControl(null, []),
  version: new FormControl(null, []),
  isArchiveInstance: new FormControl(null, []),
  enableEmergencyToken: new FormControl(null, []),
  showReports: new FormControl(null, []),
  showPatientNotes: new FormControl(null, []),
  showAppointment: new FormControl(null, []),
  showSignOffQueue: new FormControl(null, []),
  showTasks: new FormControl(null, []),
  showExportDocuments: new FormControl(null, []),
  showPatientImage: new FormControl(null, []),
  showFinancialSummary: new FormControl(null, []),
  showpatientArchive: new FormControl(null, []),
  showUserSecuriyQuestions: new FormControl(null, []),
  showPracticeMessagePopUp: new FormControl(null, []),
  enableBilling: new FormControl(null, []),
  showFinancialData: new FormControl(null, []),
  showSensitiveData: new FormControl(null, []),
  showClinicalData: new FormControl(null, []),
})

export const authTokenForm = new FormGroup({
  issuedOnUTC: new FormControl(null, []),
  expiresOnUTC: new FormControl(null, []),
  token: new FormControl(null, []),
  refreshToken: new FormControl(null, []),
  loggedInUserName: new FormControl(null, []),
  loggedInUserId: new FormControl(null, []),
  ehrUserId: new FormControl(null, []),
  userFullName: new FormControl(null, []),
  isCellVerified: new FormControl(null, []),
  mfa: new FormControl(null, []),
})

export const loginDtoForm = new FormGroup({
  clientID: new FormControl(null, []),
  userName: new FormControl(null, []),
  password: new FormControl(null, []),
})

export const mfaSetupForm = new FormGroup({
  setup: new FormControl(null, []),
  qrCode: new FormControl(null, []),
  account: new FormControl(null, []),
  key: new FormControl(null, []),
})

export const licenceModelsForm = new FormGroup({
  lName: new FormControl(null, [Validators.required, Validators.minLength(1)]),
  fName: new FormControl(null, [Validators.required, Validators.minLength(1)]),
  address: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  emailAddress: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
    Validators.email,
  ]),
  city: new FormControl(null, []),
  state: new FormControl(null, []),
  country: new FormControl(null, []),
  zipCode: new FormControl(null, []),
  phone: new FormControl(null, [Validators.required, Validators.minLength(1)]),
  keyOne: new FormControl(null, [Validators.required, Validators.minLength(1)]),
  keyTwo: new FormControl(null, [Validators.required, Validators.minLength(1)]),
  keyThree: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  keyFour: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  keyFive: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  canContinue: new FormControl(null, []),
  continueURL: new FormControl(null, []),
})

export const billingDtoForm = new FormGroup({
  facilityList: new FormControl(null, []),
  facilityId: new FormControl(null, []),
  facilityName: new FormControl(null, []),
  physicianList: new FormControl(null, []),
  physicianId: new FormControl(null, []),
  physicianName: new FormControl(null, []),
  referringList: new FormControl(null, []),
  referringId: new FormControl(null, []),
  referringName: new FormControl(null, []),
  inpatientLabelName: new FormControl(null, []),
  outpatientLabelName: new FormControl(null, []),
  officeLabelName: new FormControl(null, []),
})

export const billingForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  facilityID: new FormControl(null, []),
  facilityName: new FormControl(null, []),
  referringId: new FormControl(null, []),
  referringName: new FormControl(null, []),
  physicianId: new FormControl(null, []),
  physicianName: new FormControl(null, []),
  procedureList: new FormControl(null, []),
  procedureId: new FormControl(null, []),
  procedureName: new FormControl(null, []),
  diagnosisList: new FormControl(null, []),
  diagnosisId: new FormControl(null, []),
  diagnosisName: new FormControl(null, []),
  diagnosisCode: new FormControl(null, []),
  diag1: new FormControl(null, []),
  diag2: new FormControl(null, []),
  diag3: new FormControl(null, []),
  diag4: new FormControl(null, []),
  diag5: new FormControl(null, []),
  diag6: new FormControl(null, []),
  diag7: new FormControl(null, []),
  diag8: new FormControl(null, []),
  mod1: new FormControl(null, []),
  mod2: new FormControl(null, []),
  mod3: new FormControl(null, []),
  mod4: new FormControl(null, []),
  billingList: new FormControl(null, []),
  serviceDate: new FormControl(null, []),
  billingID: new FormControl(null, []),
  status: new FormControl(null, []),
  lastApptDate: new FormControl(null, []),
  nextApptDate: new FormControl(null, []),
  radioButtonHTML: new FormControl(null, []),
  text: new FormControl(null, []),
  value: new FormControl(null, []),
})

export const dataPageOfBillingForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const apiResponseOfStringForm = new FormGroup({
  status: new FormControl(null, []),
  message: new FormControl(null, []),
  data: new FormControl(null, []),
})

export const dataPageOfDocumentForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const documentForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  documentID: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  encID: new FormControl(null, []),
  encDate: new FormControl(null, []),
  personID: new FormControl(null, []),
  type: new FormControl(null, []),
  fileName: new FormControl(null, []),
  description: new FormControl(null, []),
  format: new FormControl(null, []),
  signedoff: new FormControl(null, []),
  databaseIndic: new FormControl(null, []),
  createdbyName: new FormControl(null, []),
  createdOn: new FormControl(null, []),
  lastModifiedOn: new FormControl(null, []),
  documentType: new FormControl(null, []),
  documentData: new FormControl(null, []),
  location: new FormControl(null, []),
})

export const categoryForm = new FormGroup({
  categoryId: new FormControl(null, []),
  categoryName: new FormControl(null, []),
})

export const exportDocumentsForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  fileName: new FormControl(null, []),
  description: new FormControl(null, []),
  format: new FormControl(null, []),
  itemType: new FormControl(null, []),
  imageType: new FormControl(null, []),
  fileType: new FormControl(null, []),
  databaseIndic: new FormControl(null, []),
  role: new FormControl(null, []),
  documentData: new FormControl(null, []),
  exportedFiles: new FormControl(null, []),
  documentExportDate: new FormControl(null, []),
  documentExportId: new FormControl(null, []),
  documentCreatedBy: new FormControl(null, []),
  documentExportName: new FormControl(null, []),
  emrDocuments: new FormControl(null, []),
  localexportedDocuments: new FormControl(null, []),
})

export const documentExportForm = new FormGroup({
  documentExportId: new FormControl(null, []),
  documentExportDate: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  documentExportName: new FormControl(null, []),
  patientId: new FormControl(null, []),
  role: new FormControl(null, []),
})

export const dataPageOfFinancialForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const financialForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  enCounterNo: new FormControl(null, []),
  renderingProvider: new FormControl(null, []),
  facilityName: new FormControl(null, []),
  billableDate: new FormControl(null, []),
  charge: new FormControl(null, []),
  charge_id: new FormControl(null, []),
  paid: new FormControl(null, []),
  adjustement: new FormControl(null, []),
  physicianName: new FormControl(null, []),
  patient: new FormControl(null, []),
  summaryList: new FormControl(null, []),
  serviceList: new FormControl(null, []),
  transactionList: new FormControl(null, []),
  badDebit: new FormControl(null, []),
  coB1: new FormControl(null, []),
  coB2: new FormControl(null, []),
  coB3: new FormControl(null, []),
  pat: new FormControl(null, []),
  insuranceSummary: new FormControl(null, []),
  encounternote: new FormControl(null, []),
  total_Charge: new FormControl(null, []),
  total_Paid: new FormControl(null, []),
  total_Adjustement: new FormControl(null, []),
  total_BadeDebit: new FormControl(null, []),
  total_COB1: new FormControl(null, []),
  total_COB2: new FormControl(null, []),
  total_COB3: new FormControl(null, []),
  total_Pat: new FormControl(null, []),
  total_adjamt: new FormControl(null, []),
  total_balance: new FormControl(null, []),
  total_Amtpaid: new FormControl(null, []),
  amtpaid: new FormControl(null, []),
  adjamt: new FormControl(null, []),
  amtbalance: new FormControl(null, []),
  dateofservice: new FormControl(null, []),
  serviceItem: new FormControl(null, []),
  tranDate: new FormControl(null, []),
  tranType: new FormControl(null, []),
  trancode: new FormControl(null, []),
  tracking: new FormControl(null, []),
  owedAmt: new FormControl(null, []),
  paidAmt: new FormControl(null, []),
  paTAmt: new FormControl(null, []),
  amount: new FormControl(null, []),
  noteid: new FormControl(null, []),
  date: new FormControl(null, []),
  noteType: new FormControl(null, []),
  noteTittle: new FormControl(null, []),
  noteMessage: new FormControl(null, []),
  rightImages: new FormControl(null, []),
  leftImages: new FormControl(null, []),
  rightInsuranceImg: new FormControl(null, []),
  leftInsuranceImg: new FormControl(null, []),
})

export const patientForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  patientId: new FormControl(null, []),
  personID: new FormControl(null, []),
  patientIDInternal: new FormControl(null, []),
  patientIDExternal: new FormControl(null, []),
  mrn: new FormControl(null, []),
  firstName: new FormControl(null, []),
  lastName: new FormControl(null, []),
  middleName: new FormControl(null, []),
  dob: new FormControl(null, []),
  ehrUserID: new FormControl(null, []),
  state: new FormControl(null, []),
  city: new FormControl(null, []),
  zip: new FormControl(null, []),
  ssn: new FormControl(null, []),
  gender: new FormControl(null, []),
  mobileNo: new FormControl(null, []),
  homePhone: new FormControl(null, []),
  officePhone: new FormControl(null, []),
  nextAppointment: new FormControl(null, []),
  lastAppointment: new FormControl(null, []),
  providerId: new FormControl(null, []),
  imageP: new FormControl(null, []),
  shortDOB: new FormControl(null, []),
  ageYears: new FormControl(null, []),
  computedGender: new FormControl(null, []),
  fullName: new FormControl(null, []),
  age: new FormControl(null, []),
  address: new FormControl(null, []),
  fullAddress: new FormControl(null, []),
  patientImage: new FormControl(null, []),
})

export const insuranceForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  insured_Id: new FormControl(null, []),
  cob: new FormControl(null, []),
  payer_Name: new FormControl(null, []),
  payer_Address: new FormControl(null, []),
  policy_Number: new FormControl(null, []),
  group_Number: new FormControl(null, []),
  insureds_name: new FormControl(null, []),
})

export const patientDemographicsForm = new FormGroup({
  add1: new FormControl(null, []),
  add2: new FormControl(null, []),
  age: new FormControl(null, []),
  dob: new FormControl(null, []),
  fullName: new FormControl(null, []),
  gender: new FormControl(null, []),
  homePhone: new FormControl(null, []),
  workPhone: new FormControl(null, []),
  mrn: new FormControl(null, []),
  mobileNo: new FormControl(null, []),
})

export const dataPageOfImageForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const imageForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  imageID: new FormControl(null, []),
  categoryID: new FormControl(null, []),
  category: new FormControl(null, []),
  documentType: new FormControl(null, []),
  documentTypeID: new FormControl(null, []),
  documentID: new FormControl(null, []),
  documentNumber: new FormControl(null, []),
  createdOn: new FormControl(null, []),
  description: new FormControl(null, []),
  displayDescription: new FormControl(null, []),
  value: new FormControl(null, []),
  documentFieldID: new FormControl(null, []),
  indexTypeID: new FormControl(null, []),
  indexValueSort: new FormControl(null, []),
  signoff: new FormControl(null, []),
  imageFile: new FormControl(null, []),
  imageFileLoc: new FormControl(null, []),
  fileType: new FormControl(null, []),
  inDataBase: new FormControl(null, []),
  img: new FormControl(null, []),
  images: new FormControl(null, []),
  categories: new FormControl(null, []),
})

export const labForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  labId: new FormControl(null, []),
  obs_batt_id: new FormControl(null, []),
  testName: new FormControl(null, []),
  testDescription: new FormControl(null, []),
  obsID: new FormControl(null, []),
  resultDescription: new FormControl(null, []),
  observationValue: new FormControl(null, []),
  abnorFlags: new FormControl(null, []),
  collectionDateTime: new FormControl(null, []),
  testCreateTimestamp: new FormControl(null, []),
  units: new FormControl(null, []),
  referenceRange: new FormControl(null, []),
  obxSeqNumber: new FormControl(null, []),
  uniqueOBRNumber: new FormControl(null, []),
  signedoff: new FormControl(null, []),
  obsDateTime: new FormControl(null, []),
  encID: new FormControl(null, []),
  resultCreateTimestamp: new FormControl(null, []),
  resultSeqNumber: new FormControl(null, []),
  comment: new FormControl(null, []),
  cpT4Code: new FormControl(null, []),
  patientId: new FormControl(null, []),
  orderDate: new FormControl(null, []),
  testCount: new FormControl(null, []),
  databaseIndic: new FormControl(null, []),
  date: new FormControl(null, []),
  labs: new FormControl(null, []),
  graphImage: new FormControl(null, []),
  graphList: new FormControl(null, []),
  graphValue: new FormControl(null, []),
  shortLabDate: new FormControl(null, []),
})

export const dataPageOfLabForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const dataPageOfMedicationForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const medicationForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  medicationId: new FormControl(null, []),
  brandName: new FormControl(null, []),
  brandDoseForm: new FormControl(null, []),
  genericName: new FormControl(null, []),
  medicationName: new FormControl(null, []),
  dose: new FormControl(null, []),
  doseFormDescription: new FormControl(null, []),
  routeDescription: new FormControl(null, []),
  startDate: new FormControl(null, []),
  dateStopped: new FormControl(null, []),
  rxQuanity: new FormControl(null, []),
  rxUnits: new FormControl(null, []),
  rxRefills: new FormControl(null, []),
  genericOk: new FormControl(null, []),
  samples: new FormControl(null, []),
  orgRefills: new FormControl(null, []),
  lastRefilledDate: new FormControl(null, []),
  sigCodes: new FormControl(null, []),
  sigDescription: new FormControl(null, []),
  prescribedElse: new FormControl(null, []),
  rx_Comment: new FormControl(null, []),
  diagnosisCodeID: new FormControl(null, []),
  deaID: new FormControl(null, []),
  providerName: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  encTimestamp: new FormControl(null, []),
  patientId: new FormControl(null, []),
  shortStartDate: new FormControl(null, []),
  shortDateStopped: new FormControl(null, []),
  medications: new FormControl(null, []),
})

export const notesTemplateForm = new FormGroup({
  notesTemplateId: new FormControl(null, []),
  notesCategoryId: new FormControl(null, []),
  notesCategoryName: new FormControl(null, []),
  description: new FormControl(null, [
    Validators.minLength(0),
    Validators.maxLength(1000),
  ]),
  templateName: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  templateData: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  createdBy: new FormControl(null, []),
  modifiedBY: new FormControl(null, []),
  isdeleted: new FormControl(null, []),
})

export const notesTemplateDtoForm = new FormGroup({
  categoryId: new FormControl(null, []),
  categoryName: new FormControl(null, []),
  description: new FormControl(null, [
    Validators.minLength(0),
    Validators.maxLength(1000),
  ]),
  templateName: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
  templateData: new FormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]),
})

export const noteForm = new FormGroup({
  categoryId: new FormControl(null, []),
  categoryName: new FormControl(null, []),
  providerId: new FormControl(null, []),
  providerName: new FormControl(null, []),
  noteTitle: new FormControl(null, []),
  noteDate: new FormControl(null, []),
  templateName: new FormControl(null, []),
  templateId: new FormControl(null, []),
  providers: new FormControl(null, []),
  categories: new FormControl(null, []),
  templates: new FormControl(null, []),
  patientId: new FormControl(null, []),
  practiceId: new FormControl(null, []),
})

export const templateForm = new FormGroup({
  templateId: new FormControl(null, []),
  templateName: new FormControl(null, []),
})

export const orderClassForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  orderClassID: new FormControl(null, []),
  classDescription: new FormControl(null, []),
})

export const dataPageOfOrderForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const orderForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  orderID: new FormControl(null, []),
  seqNo: new FormControl(null, []),
  class: new FormControl(null, []),
  encId: new FormControl(null, []),
  enDate: new FormControl(null, []),
  personId: new FormControl(null, []),
  code: new FormControl(null, []),
  comments: new FormControl(null, []),
  description: new FormControl(null, []),
  diagnosis: new FormControl(null, []),
  textDisplay: new FormControl(null, []),
  seqNum: new FormControl(null, []),
  status: new FormControl(null, []),
  ordered: new FormControl(null, []),
  orderedBy: new FormControl(null, []),
  orderedDate: new FormControl(null, []),
  orderedReason: new FormControl(null, []),
  providerName: new FormControl(null, []),
  locationName: new FormControl(null, []),
  obsInterpretation: new FormControl(null, []),
  obsNumericalval: new FormControl(null, []),
  obsPhysicalunits: new FormControl(null, []),
  obsValue: new FormControl(null, []),
  completed: new FormControl(null, []),
  completedBy: new FormControl(null, []),
  cancelled: new FormControl(null, []),
  cancelled_by: new FormControl(null, []),
  cancelledReason: new FormControl(null, []),
  orderclass: new FormControl(null, []),
})

export const archiveTemplateForm = new FormGroup({
  text: new FormControl(null, []),
  value: new FormControl(null, []),
  clinicalSettings: new FormControl(null, []),
  billingSettings: new FormControl(null, []),
  significantSettings: new FormControl(null, []),
})

export const patientArchiveSettingsForm = new FormGroup({
  archiveSettingId: new FormControl(null, []),
  isArchiveExpiredPatients: new FormControl(null, []),
  isRestorePatients: new FormControl(null, []),
  daysPriorTo: new FormControl(null, []),
  clinicalArchiveByName: new FormControl(null, []),
  clinicalArchiveByValue: new FormControl(null, []),
  clinicalThreshHold: new FormControl(null, []),
  clinicalSettings: new FormControl(null, []),
  billingArchiveByName: new FormControl(null, []),
  billingArchiveByValue: new FormControl(null, []),
  billingThreshHold: new FormControl(null, []),
  billingSettings: new FormControl(null, []),
  significantSettings: new FormControl(null, []),
  significantValue: new FormControl(null, []),
  userId: new FormControl(null, []),
  create_timestamp: new FormControl(null, []),
})

export const dataPageOfPatientArchiveForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const patientArchiveForm = new FormGroup({
  patientArchiveId: new FormControl(null, []),
  patientId: new FormControl(null, []),
  lastName: new FormControl(null, []),
  firstName: new FormControl(null, []),
  mrn: new FormControl(null, []),
  dob: new FormControl(null, []),
  archiveDate: new FormControl(null, []),
  restoreCondition: new FormControl(null, []),
  startDate: new FormControl(null, []),
  endDate: new FormControl(null, []),
  userId: new FormControl(null, []),
})

export const dataPageOfPatientForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const dataPageOfSignificantEventsForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const significantEventsForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  date: new FormControl(null, []),
  enc_nbr: new FormControl(null, []),
  event_description: new FormControl(null, []),
  sig_msg: new FormControl(null, []),
  pre_modification: new FormControl(null, []),
  post_modification: new FormControl(null, []),
  created_by: new FormControl(null, []),
  create_timestamp: new FormControl(null, []),
  modified_by: new FormControl(null, []),
  modify_timestamp: new FormControl(null, []),
})

export const dashboardForm = new FormGroup({
  providerId: new FormControl(null, []),
  providers: new FormControl(null, []),
  search: new FormControl(null, []),
  patient: new FormControl(null, []),
  problems: new FormControl(null, []),
  allergies: new FormControl(null, []),
  medications: new FormControl(null, []),
  visits: new FormControl(null, []),
  labs: new FormControl(null, []),
  documents: new FormControl(null, []),
  images: new FormControl(null, []),
  notes: new FormControl(null, []),
  order: new FormControl(null, []),
})

export const problemForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  problemId: new FormControl(null, []),
  type: new FormControl(null, []),
  problemDescription: new FormControl(null, []),
  onSetDate: new FormControl(null, []),
  diagnosisCodeID: new FormControl(null, []),
  encID: new FormControl(null, []),
  personID: new FormControl(null, []),
  isResolved: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  diagnosedDate: new FormControl(null, []),
  resolvedDate: new FormControl(null, []),
  severity: new FormControl(null, []),
  statusDescription: new FormControl(null, []),
  dxPriority: new FormControl(null, []),
  note: new FormControl(null, []),
  providerName: new FormControl(null, []),
  locationName: new FormControl(null, []),
  enteredBy: new FormControl(null, []),
  reason: new FormControl(null, []),
  patientId: new FormControl(null, []),
  shortVisitDate: new FormControl(null, []),
  computedSeverity: new FormControl(null, []),
  problems: new FormControl(null, []),
})

export const visitForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  visitId: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  visitType: new FormControl(null, []),
  renderingProvider: new FormControl(null, []),
  isBillable: new FormControl(null, []),
  isClinical: new FormControl(null, []),
  isLocked: new FormControl(null, []),
  encID: new FormControl(null, []),
  appointmentID: new FormControl(null, []),
  appointmentDetails: new FormControl(null, []),
  appointmentReason: new FormControl(null, []),
  location: new FormControl(null, []),
  patientId: new FormControl(null, []),
  shortVisitDate: new FormControl(null, []),
})

export const manageRolesForm = new FormGroup({
  roleId: new FormControl(null, []),
  privilege: new FormControl(null, []),
  roleDescription: new FormControl(null, []),
  roleName: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedBy: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
})

export const practiceForm = new FormGroup({
  practiceid: new FormControl(null, []),
  clientId: new FormControl(null, []),
  name: new FormControl(null, []),
  contactlname: new FormControl(null, []),
  contactfname: new FormControl(null, []),
  contactmi: new FormControl(null, []),
  contactemail: new FormControl(null, []),
  address1: new FormControl(null, []),
  address2: new FormControl(null, []),
  city: new FormControl(null, []),
  state: new FormControl(null, []),
  zip: new FormControl(null, []),
  officephone: new FormControl(null, []),
  alternatephone: new FormControl(null, []),
  fax2: new FormControl(null, []),
  createtimestamp: new FormControl(null, []),
  modifytimestamp: new FormControl(null, []),
  lastpulldate: new FormControl(null, []),
  rovinglocation: new FormControl(null, []),
  dflthomelocation: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  emrDBName: new FormControl(null, []),
  emrLastName: new FormControl(null, []),
  emrFirstName: new FormControl(null, []),
  emrMi: new FormControl(null, []),
  message: new FormControl(null, []),
  defaultProviderId: new FormControl(null, []),
  defaultProviderName: new FormControl(null, []),
})

export const dataPageOfProblemForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const recentlyVisitedForm = new FormGroup({
  id: new FormControl(null, []),
  patientId: new FormControl(null, []),
  patientName: new FormControl(null, []),
  practiceId: new FormControl(null, []),
  userId: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  modifiedBy: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  createtimestamp: new FormControl(null, []),
  modifytimestamp: new FormControl(null, []),
})

export const dataPageOfReportCategoryForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const reportCategoryForm = new FormGroup({
  reportcategoryid: new FormControl(null, []),
  reportcategoryname: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createtimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifytimestamp: new FormControl(null, []),
  isAdmin: new FormControl(null, []),
  reports: new FormControl(null, []),
})

export const reportForm = new FormGroup({
  reportID: new FormControl(null, []),
  reportFileName: new FormControl(null, []),
  reportShortNote: new FormControl(null, []),
  reportDisplayName: new FormControl(null, []),
  reportCategoryID: new FormControl(null, []),
  patientFlag: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  createTimeStamp: new FormControl(null, []),
  modifiedBy: new FormControl(null, []),
  modifyTimeStamp: new FormControl(null, []),
  reportCategoryName: new FormControl(null, []),
  reportCategory: new FormControl(null, []),
})

export const dataPageOfReportParamForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const reportParamForm = new FormGroup({
  reportparamid: new FormControl(null, []),
  reportid: new FormControl(null, []),
  reportparamname: new FormControl(null, []),
  reportparamshortnote: new FormControl(null, []),
  sortorder: new FormControl(null, []),
  datatype: new FormControl(null, []),
  picklistValues: new FormControl(null, []),
  minnumber: new FormControl(null, []),
  maxnumber: new FormControl(null, []),
  mindate: new FormControl(null, []),
  maxdate: new FormControl(null, []),
  startTime: new FormControl(null, []),
  endTime: new FormControl(null, []),
  startDateTime: new FormControl(null, []),
  endDateTime: new FormControl(null, []),
  minCurrency: new FormControl(null, []),
  maxCurrency: new FormControl(null, []),
  isrequired: new FormControl(null, []),
  maxstringlength: new FormControl(null, []),
  defaultvalue: new FormControl(null, []),
  isLookUp: new FormControl(null, []),
  tableName: new FormControl(null, []),
  valueColumnName: new FormControl(null, []),
  displayieldName: new FormControl(null, []),
  seqno: new FormControl(null, []),
  createdby: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
})

export const globalattributesForm = new FormGroup({
  settingName: new FormControl(null, []),
  settingValue: new FormControl(null, []),
  globalattributesSettings: new FormControl(null, []),
})

export const dataPageOfReportForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const dataPageOfManageRolesForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const carefinityRolesForm = new FormGroup({
  changePassword: new FormControl(null, []),
  tasks: new FormControl(null, []),
  appointment: new FormControl(null, []),
  patientSearch: new FormControl(null, []),
  signOffQueue: new FormControl(null, []),
  viewReports: new FormControl(null, []),
  manageReports: new FormControl(null, []),
  manageNotes: new FormControl(null, []),
  manageUsers: new FormControl(null, []),
  manageRoles: new FormControl(null, []),
  manageUserPractices: new FormControl(null, []),
  resetAllPasswords: new FormControl(null, []),
  patientArchive: new FormControl(null, []),
  securityQuestions: new FormControl(null, []),
  emergencyToken: new FormControl(null, []),
  patientDemographics: new FormControl(null, []),
  dashboard: new FormControl(null, []),
  allergies: new FormControl(null, []),
  problems: new FormControl(null, []),
  visits: new FormControl(null, []),
  images: new FormControl(null, []),
  documents: new FormControl(null, []),
  labs: new FormControl(null, []),
  orders: new FormControl(null, []),
  vitals: new FormControl(null, []),
  exportdocuments: new FormControl(null, []),
  charge: new FormControl(null, []),
  financialSummary: new FormControl(null, []),
  significantEvents: new FormControl(null, []),
  medication: new FormControl(null, []),
  notes: new FormControl(null, []),
  checkAll: new FormControl(null, []),
  showFinancialData: new FormControl(null, []),
  showSensitiveData: new FormControl(null, []),
  showClinicalData: new FormControl(null, []),
  roleName: new FormControl(null, []),
  roleDescription: new FormControl(null, []),
})

export const samlResponseDtoForm = new FormGroup({
  token: new FormControl(null, []),
  patient: new FormControl(null, []),
})

export const samlDtoForm = new FormGroup({
  samlResponse: new FormControl(null, []),
  relayState: new FormControl(null, []),
})

export const securityAnswerForm = new FormGroup({
  answerId: new FormControl(null, []),
  questionId: new FormControl(null, []),
  userId: new FormControl(null, []),
  answerDescription: new FormControl(null, []),
})

export const securityAnswersDtoForm = new FormGroup({
  securityAnswers: new FormControl(null, []),
})

export const securityAnswerDtoForm = new FormGroup({
  questionId: new FormControl(null, []),
  answerDescription: new FormControl(null, []),
})

export const dataPageOfSecurityQuestionsForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const securityQuestionsForm = new FormGroup({
  questionId: new FormControl(null, []),
  description: new FormControl(null, []),
})

export const dataPageOfPhysicianQueueItemForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const physicianQueueItemForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  physicianQueueItemId: new FormControl(null, []),
  itemType: new FormControl(null, []),
  itemId: new FormControl(null, []),
  personId: new FormControl(null, []),
  visitId: new FormControl(null, []),
  visitDate: new FormControl(null, []),
  itemName: new FormControl(null, []),
  itemDescription: new FormControl(null, []),
  format: new FormControl(null, []),
  createdById: new FormControl(null, []),
  created: new FormControl(null, []),
  appCreatedBy: new FormControl(null, []),
  userId: new FormControl(null, []),
  lastName: new FormControl(null, []),
  firstName: new FormControl(null, []),
  middleName: new FormControl(null, []),
  createdByName: new FormControl(null, []),
  modified_by: new FormControl(null, []),
  perm_pos: new FormControl(null, []),
  providerId: new FormControl(null, []),
  patientName: new FormControl(null, []),
  uniqueId: new FormControl(null, []),
  dbIndic: new FormControl(null, []),
})

export const tasksDtoForm = new FormGroup({
  userId: new FormControl(null, []),
  userName: new FormControl(null, []),
  tabId: new FormControl(null, []),
  tabName: new FormControl(null, []),
  taskdelList: new FormControl(null, []),
  taskTablList: new FormControl(null, []),
  tasks: new FormControl(null, []),
})

export const taskForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  taskId: new FormControl(null, []),
  dueDate: new FormControl(null, []),
  priority: new FormControl(null, []),
  subject: new FormControl(null, []),
  description: new FormControl(null, []),
  category: new FormControl(null, []),
  isCompleted: new FormControl(null, []),
  userId: new FormControl(null, []),
  patientName: new FormControl(null, []),
  sender: new FormControl(null, []),
  patient_accid: new FormControl(null, []),
})

export const dataPageOfTaskForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const userForm = new FormGroup({
  userId: new FormControl(null, []),
  password: new FormControl(null, []),
  userPassword: new FormControl(null, []),
  loginId: new FormControl(null, []),
  lname: new FormControl(null, []),
  fname: new FormControl(null, []),
  mi: new FormControl(null, []),
  active: new FormControl(null, []),
  roleId: new FormControl(null, []),
  ehrUserId: new FormControl(null, []),
  forcePswdChg: new FormControl(null, []),
  allowPswdChg: new FormControl(null, []),
  pswdChgOn: new FormControl(null, []),
  isLocked: new FormControl(null, []),
  failedLoginCount: new FormControl(null, []),
  emailAddress: new FormControl(null, []),
  cellNo: new FormControl(null, []),
  isCellVerified: new FormControl(null, []),
  failedOtpValidationCount: new FormControl(null, []),
  ehrUserName: new FormControl(null, []),
  userRole: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedBy: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  userName: new FormControl(null, []),
  userPractices: new FormControl(null, []),
  roles: new FormControl(null, []),
  defaultProviderId: new FormControl(null, []),
  defaultProviderName: new FormControl(null, []),
  authAppSetup: new FormControl(null, []),
  authAppKey: new FormControl(null, []),
})

export const userPracticeForm = new FormGroup({
  userPracticeId: new FormControl(null, []),
  userId: new FormControl(null, []),
  practiceId: new FormControl(null, []),
  createdBy: new FormControl(null, []),
  createtimestamp: new FormControl(null, []),
  modifiedBy: new FormControl(null, []),
  modifytimestamp: new FormControl(null, []),
})

export const dataPageOfUserForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const dataPageOfEhrUsersForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const ehrUsersForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  userId: new FormControl(null, []),
  lastName: new FormControl(null, []),
  firstName: new FormControl(null, []),
  mi: new FormControl(null, []),
  userName: new FormControl(null, []),
  isActive: new FormControl(null, []),
  loginID: new FormControl(null, []),
  userKey: new FormControl(null, []),
  providerID: new FormControl(null, []),
  description: new FormControl(null, []),
  practiceName: new FormControl(null, []),
  ehrUser: new FormControl(null, []),
  fullName: new FormControl(null, []),
})

export const dataPageOfVisitForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const dataPageOfVitalForm = new FormGroup({
  pageSize: new FormControl(null, []),
  pageNumber: new FormControl(null, []),
  totalRecords: new FormControl(null, []),
  data: new FormControl(null, []),
  totalPages: new FormControl(null, []),
})

export const vitalForm = new FormGroup({
  practiceId: new FormControl(null, []),
  enterpriseId: new FormControl(null, []),
  emrPracticeId: new FormControl(null, []),
  connStringId: new FormControl(null, []),
  configFileName: new FormControl(null, []),
  practiceMsg: new FormControl(null, []),
  defaultEHRUserId: new FormControl(null, []),
  createdby: new FormControl(null, []),
  createTimestamp: new FormControl(null, []),
  modifiedby: new FormControl(null, []),
  modifyTimestamp: new FormControl(null, []),
  otherColumns: new FormControl(null, []),
  savedColumns: new FormControl(null, []),
  vitalId: new FormControl(null, []),
  date: new FormControl(null, []),
  height: new FormControl(null, []),
  weight: new FormControl(null, []),
  temp: new FormControl(null, []),
  pulse: new FormControl(null, []),
  bmi: new FormControl(null, []),
  bp: new FormControl(null, []),
  heartRate: new FormControl(null, []),
  resp: new FormControl(null, []),
  spo2: new FormControl(null, []),
  headCirc: new FormControl(null, []),
  patientId: new FormControl(null, []),
  age_in_months: new FormControl(null, []),
  graphImage: new FormControl(null, []),
  graphList: new FormControl(null, []),
  graphValue: new FormControl(null, []),
  shortVitalDate: new FormControl(null, []),
  flagHeight: new FormControl(null, []),
  flagWeight: new FormControl(null, []),
})
